import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker} from 'google-maps-react';
import '../css/getViewUbication.css';


class getViewUbication extends Component {
  constructor(props) {
    super(props);
    //this.mapRef = React.createRef();
    this.state = {
       markers: [
         {
           name: "Current position",
           position: {
             lat: this.props.lat,
             lng: this.props.lon
           }
         }
       ],
       mounted : false,
       mapStyles: [
     {
     "featureType": "administrative.neighborhood",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.man_made",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural.landcover",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "landscape.natural.terrain",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.attraction",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.business",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.government",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.medical",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.park",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "poi.place_of_worship",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.school",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "poi.sports_complex",
     "stylers": [
     {
     "visibility": "off"
     }
     ]
     },
     {
     "featureType": "road.highway",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "road.local",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "transit.station",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     },
     {
     "featureType": "water",
     "stylers": [
     {
     "visibility": "on"
     }
     ]
     }
     ]
     };
  }
  /*


  */
  render() {
    return (
      <div className="modal-dialog-view_ubication">
        <div className="modal-content-view_ubication">
          <div className="grid-container-menu_list-view_ubication">
            <div className="div_menu_1_list-view_ubication">
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } onClick={ () => this.props.get_go_to_sub("")} />
            </div>
            <div className="lbl_menu_2_list-view_ubication">
              <span className="span-global-link">Vista Previa Entrega</span>
            </div>
          </div>

          <div className="div_contenedor_map">
            <div className="div_row_contenedor_map-map">
              <Map
              google={this.props.google}
              style={{
                width:"90%",
                height: "500px",
                left: "10px",
                right: "10px",
                position: 'relative'
              }}
              zoom={18}
              ref={this.mapRef}
              initialCenter={{ lat: this.props.lat, lng: this.props.lon }}
              disableDefaultUI ={true}
              styles={this.state.mapStyles}
              >
              {this.state.markers.map((marker, index) => (
                <Marker
                  position={marker.position}
                  draggable={false}
                  name={marker.name}
                  key={index}
                />
              ))}
              </Map>
            </div>
          </div>
        </div>
      </div>
    )
  }

}
export default GoogleApiWrapper({
  apiKey: 'AIzaSyAtyO9FEIXPiDDSLE1a88MNGVpLKgxnxqo'
})(getViewUbication);

//export default getViewUbication;
